import { API_ENDPOINTS, api } from "../apis/constants";
import { OrderHistory, OrderRequest } from "../types/order";

class OrderService {
    async createOrderForGuest(order: OrderRequest): Promise<any> {
        try {
            if (localStorage.getItem('auth_token')) {
                const response = await api.post(API_ENDPOINTS.ORDERS.CREATE_USER, order);
                return response.data;
            } else {
                const response = await api.post(API_ENDPOINTS.ORDERS.CREATE_GUEST, order);
                return response.data;
            }
        } catch (error) {
            throw error;
        }
    }

    async createOrderForUser(order: OrderRequest): Promise<any> {
        try {
            const response = await api.post(API_ENDPOINTS.ORDERS.CREATE_USER, order);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async getOrderHistory(): Promise<OrderHistory> {
        try {
            const response = await api.get(API_ENDPOINTS.ORDERS.HISTORY);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export const orderService = new OrderService();